var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CheckmarkGreenFull = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '60', height: '60', viewBox: '0 0 60 60', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("g", __assign({ clipPath: 'url(#clip0_2453_4578)' }, { children: _jsx("path", { d: 'M30 0C13.5 0 0 13.5 0 30C0 46.5 13.5 60 30 60C46.5 60 60 46.5 60 30C60 13.5 46.5 0 30 0ZM23.75 45.75L9.75 31.5L14.25 27L24 36.75L45 15.75L49.5 20.25L23.75 45.75Z', fill: '#33840C' }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: 'clip0_2453_4578' }, { children: _jsx("rect", { width: '60', height: '60', fill: 'white' }) })) })] })));
};
export { CheckmarkGreenFull };
//# sourceMappingURL=CheckmarkGreenFull.js.map